import React from "react";
import { Link } from "react-router-dom";

export default function FooterSection() {
  return (
    <footer id="main-footer" className="bg-zinc-950 text-white/70 py-12 px-4 md:px-6 font-sans text-xs border-t border-white/10">
      <div className="max-w-[1120px] mx-auto space-y-6">
        
        {/* Core Attribution */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-b border-white/5 pb-6">
          <div className="text-center md:text-left">
            <span className="font-display font-black text-sm text-white uppercase tracking-wider block">
              DEBT COLLECTOR KILL SWITCH
            </span>
            <span className="text-[10px] text-white/40 block mt-1">
              Fulfilled by TDCR Consulting, LLC
            </span>
          </div>
          
          {/* Legal / Contact links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-[10px] uppercase font-bold tracking-wider">
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-brand-yellow transition-colors">Terms</Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-brand-yellow transition-colors">Privacy</Link>
            <Link to="/refund-policy" data-testid="footer-refund-policy-link" className="hover:text-brand-yellow transition-colors">Refund Policy</Link>
            <Link to="/sms-terms" data-testid="footer-sms-terms-link" className="hover:text-brand-yellow transition-colors">SMS Terms</Link>
            <Link to="/contact" data-testid="footer-contact-faq-link" className="hover:text-brand-yellow transition-colors">Contact Us / FAQ</Link>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="text-white/45 space-y-3 leading-relaxed max-w-4xl">
          <p className="font-bold text-white/60">LEGAL & FINANCIAL DISCLAIMER:</p>
          <p className="text-justify">
            The Debt Collector Kill Switch is a self-help educational document system intended solely for consumer information purposes. TDCR Consulting LLC is not a law firm, does not employ licensed attorneys, and does not provide formal legal advice, representation, or credit repair services. Purchasing this system does not establish an attorney-client relationship.
          </p>
          <p className="text-justify">
            Any dispute files, rebuttal templates, complain forms, or instructions contained herein are tools based on public statues including the Fair Debt Collection Practices Act (FDCPA) and Fair Credit Reporting Act (FCRA). While these letters and procedures have proved historically effective for many users, individual credit files, accounts, and collection agencies vary. TDCR Consulting LLC makes no guarantees, warranties, or representations regarding specific outcomes, score increases, or collection removals.
          </p>
          <p className="text-justify">
            In court matters, formal lawsuits, wage garnishment responses, or bankruptcy situations, you are strongly advised to consult with a licensed consumer defense attorney in your home state to obtain competent legal guidance.
          </p>
        </div>

        {/* Small Print Copyright */}
        <div className="text-center text-[10px] text-white/30 pt-4">
          © {new Date().getFullYear()} TDCR Consulting LLC. All Rights Reserved.
        </div>

      </div>
    </footer>
  );
}
